import { HStack, View, Box, useTheme, IconButton, CloseIcon } from 'native-base';
import { useTranslation } from 'react-i18next';

import { Button, Text, UploadCloudIcon } from '@pimm/base';

type WeeklyGoalsConfirmUnSaveProps = {
  onClose?: () => void;
  onConfirm?: () => void;
};

export const WeeklyGoalsConfirmUnSave = (props: WeeklyGoalsConfirmUnSaveProps) => {
  const { colors } = useTheme();
  const { t } = useTranslation();

  return (
    <View position="relative" p={5}>
      <HStack alignItems="flex-start" justifyContent="space-between" mb={4}>
        <Box flex="none" rounded="full" p={2} bg="warning.50">
          <Box rounded="full" p={2} bg="warning.100">
            <UploadCloudIcon size={5} color={colors.warning[600]} />
          </Box>
        </Box>
        <IconButton
          variant="unstyled"
          position="absolute"
          top={-5}
          right={-5}
          p={0}
          boxSize={8}
          _pressed={{ bg: 'gray.50' }}
          _hover={{ bg: 'gray.50' }}
          icon={<CloseIcon size={4} color="gray.700" />}
          onPress={props.onClose}
        />
      </HStack>

      <Box mb={3}>
        <Text color="black" fontWeight={600} size="xl" mb={2} lineHeight="sm">
          {t('ops_plan:unsaved_changes')}
        </Text>
        <Text color="gray.900" fontWeight={500} size="md" mb={3} lineHeight="sm">
          {`${t('ops_plan:discard_changes_prompt')}?`}
        </Text>
      </Box>

      <HStack space={2}>
        <Button flex={1} variant="unstyled" onPress={props.onClose}>
          {t('app:cancel')}
        </Button>
        <Button flex={1} onPress={props.onConfirm}>
          {t('app:confirm')}
        </Button>
      </HStack>
    </View>
  );
};
